import styled from "styled-components";

export const CardContainer = styled.div`
  position: relative;
  border-radius: ${({ borderRadius }) => `${borderRadius}px`};
  padding: 28px 14px;
  overflow: hidden;
  height: 100%;
  box-sizing: border-box;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: url(${({ imageUrl }) => imageUrl});
    background-position: center;
    background-size: cover;
    filter: blur(30px);
    z-index: 2;
  }
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 28px;
  z-index: 3;
  position: relative;
  height: 100%;
`;

export const CardContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 28px;
`;

export const CardHeading = styled.h1`
  margin: 0;
  color: #ffffff;
  font-weight: 500;
  text-align: center;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const CardImage = styled.img`
  object-fit: cover;
  border-radius: 9999px;
  object-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
`;

export const CardLabel = styled.span`
  padding: ${({ isEditable }) => `${isEditable ? 8 : 5}px`} 10px 5px;
  font-size: 12px;
  color: ${({ color }) => color};
  background: ${({ background }) => background};
  border-radius: 9999px;
  width: fit-content;
  box-sizing: border-box;
`;

export const CardLinkText = styled.span`
  color: #ffffff;
`;

export const CardArrowContainer = styled.div`
  opacity: 0.5;
  height: 20px;
`;
